import { createContext } from '@change-corgi/core/react/context';

import type { Ds2ExperimentData } from './types';

export const {
	Context: Ds2ExperimentContext,
	Provider: Ds2ExperimentProvider,
	useContext: useDs2ExperimentContext,
} = createContext<Ds2ExperimentData | undefined>(undefined, { name: 'Ds2ExperimentContext' });
